import {InputField} from '@nlabs/gothamjs/components';
import {Eye, EyeOff} from '@nlabs/gothamjs/icons';
import {useState} from 'react';

import type {ComponentProps, ReactElement} from 'react';

interface AuthFieldProps extends Omit<ComponentProps<typeof InputField>, 'className'> {
  readonly id: string;
  readonly label: string;
}

const inputClass = 'w-full! min-w-0! rounded-2xl! border! border-white/60! bg-white/40! px-4! py-3! '
  + 'text-base! sm:text-sm! leading-6! text-slate-950! shadow-none! placeholder:text-slate-600! '
  + 'focus:border-violet-700/50! focus:outline-none! focus:ring-2! focus:ring-violet-700/20!';

export const AuthField = ({id, label, type = 'text', ...props}: AuthFieldProps): ReactElement => {
  const [visible, setVisible] = useState(false);
  const isPassword = type === 'password';
  return (
    <div>
      <label className="mb-2 block text-sm font-semibold text-violet-950/80" htmlFor={id}>{label}</label>
      <div className="relative">
        <InputField
          {...props}
          borderType="none"
          className={`${inputClass} ${isPassword ? 'pr-12!' : ''}`}
          id={id}
          type={isPassword && visible ? 'text' : type}
        />
        {isPassword && (
          <button
            aria-label={`${visible ? 'Hide' : 'Show'} ${label.toLowerCase()}`}
            aria-pressed={visible}
            className="absolute inset-y-0 right-1 flex w-11 items-center justify-center rounded-xl text-sky-950 transition hover:text-violet-900 focus-visible:outline-2 focus-visible:outline-violet-700"
            onClick={() => setVisible(!visible)}
            type="button">
            {visible ? <EyeOff aria-hidden="true" size={18} /> : <Eye aria-hidden="true" size={18} />}
          </button>
        )}
      </div>
    </div>
  );
};
